import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { analisesAPI } from '../../services/inovacaoAPI';
import { setoresAPI, authAPI } from '../../services/api';

const FIELD = { marginBottom: 16 };
const LABEL = { display: 'block', marginBottom: 4, fontWeight: 500, color: '#333' };
const INPUT = { width: '100%', padding: 10, borderRadius: 4, border: '1px solid #ccc', fontSize: '0.9rem' };
const CARD = { background: '#fff', padding: 24, borderRadius: 8, marginBottom: 16,
               boxShadow: '0 1px 3px rgba(0,0,0,0.06)' };

export default function NovaAnalise() {
  const navigate = useNavigate();
  const [setores, setSetores] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [form, setForm] = useState({
    titulo: '',
    propriedade: 'Setor de Inovação (GNI)',
    setor_solicitante_id: '',
    responsavel_respostas_id: '',
    responsavel_tecnico_id: '',
    gerente_area_id: '',
    resumo_executivo: '',
    objetivo: '',
    setores_impactados_ids: [],
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setoresAPI.list().then((r) => setSetores(r.data)).catch(() => toast.error('Erro ao carregar setores'));
    authAPI.listUsers().then((r) => setUsuarios(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.titulo || !form.setor_solicitante_id || !form.responsavel_respostas_id) {
      toast.error('Título, setor mais impactado e operador (responsável pelas respostas) são obrigatórios');
      return;
    }
    setSaving(true);
    try {
      const criada = await analisesAPI.criar({
        ...form,
        setor_solicitante_id: parseInt(form.setor_solicitante_id),
        responsavel_respostas_id: parseInt(form.responsavel_respostas_id),
        responsavel_tecnico_id: form.responsavel_tecnico_id ? parseInt(form.responsavel_tecnico_id) : null,
        gerente_area_id: form.gerente_area_id ? parseInt(form.gerente_area_id) : null,
        setores_impactados_ids: form.setores_impactados_ids.map((i) => parseInt(i)),
      });
      toast.success('Análise criada. Agora você pode preencher a Comparativa e convidar o operador');
      navigate(`/inovacao/analises/${criada.id}`);
    } catch (err) {
      toast.error(err.response?.data?.detail?.message || err.response?.data?.detail || 'Erro ao criar');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 32, maxWidth: 880, margin: '0 auto', background: '#f5f7fa', minHeight: '100vh' }}>
      <h1 style={{ color: '#2c3e50', marginBottom: 4 }}>Nova análise de oportunidade</h1>
      <p style={{ color: '#7f8c8d', marginTop: 0, marginBottom: 24 }}>
        Preenchida pelo analista. Depois da criação, você adiciona a Análise Comparativa e convida o operador para responder o questionário.
      </p>

      <form onSubmit={submit}>
        {/* Dados do projeto */}
        <div style={CARD}>
          <h3 style={{ margin: '0 0 16px', color: 'var(--brand, #20a490)' }}>Dados do Projeto</h3>

          <div style={FIELD}>
            <label style={LABEL}>Nome do projeto *</label>
            <input style={INPUT} value={form.titulo}
                   placeholder="Ex: Agrupamento de Títulos CNAB 240"
                   onChange={(e) => setForm({ ...form, titulo: e.target.value })} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
            <div>
              <label style={LABEL}>Responsável Técnico</label>
              <select style={INPUT} value={form.responsavel_tecnico_id}
                      onChange={(e) => setForm({ ...form, responsavel_tecnico_id: e.target.value })}>
                <option value="">Você (padrão)</option>
                {usuarios.map((u) => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
              </select>
            </div>
            <div>
              <label style={LABEL}>Gerente da Área</label>
              <select style={INPUT} value={form.gerente_area_id}
                      onChange={(e) => setForm({ ...form, gerente_area_id: e.target.value })}>
                <option value="">—</option>
                {usuarios.map((u) => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
              </select>
            </div>
          </div>

          <div style={FIELD}>
            <label style={LABEL}>Propriedade</label>
            <input style={INPUT} value={form.propriedade}
                   onChange={(e) => setForm({ ...form, propriedade: e.target.value })} />
            <small style={{ color: '#7f8c8d' }}>A quem pertence a iniciativa (default: Setor de Inovação, GNI)</small>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <label style={LABEL}>Setor mais impactado *</label>
              <select style={INPUT} value={form.setor_solicitante_id}
                      onChange={(e) => setForm({ ...form, setor_solicitante_id: e.target.value })}>
                <option value="">—</option>
                {setores.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}
              </select>
            </div>
            <div>
              <label style={LABEL}>Operador (responderá o questionário) *</label>
              <select style={INPUT} value={form.responsavel_respostas_id}
                      onChange={(e) => setForm({ ...form, responsavel_respostas_id: e.target.value })}>
                <option value="">—</option>
                {usuarios.map((u) => <option key={u.id} value={u.id}>{u.nome_completo}</option>)}
              </select>
            </div>
          </div>

          <div style={{ ...FIELD, marginTop: 16 }}>
            <label style={LABEL}>Outros setores impactados (opcional)</label>
            <select multiple style={{ ...INPUT, minHeight: 100 }}
                    value={form.setores_impactados_ids}
                    onChange={(e) => setForm({
                      ...form,
                      setores_impactados_ids: Array.from(e.target.selectedOptions, (o) => o.value),
                    })}>
              {setores.map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}
            </select>
            <small style={{ color: '#7f8c8d' }}>Ctrl/Cmd+click para selecionar múltiplos</small>
          </div>
        </div>

        {/* Contexto narrativo */}
        <div style={CARD}>
          <h3 style={{ margin: '0 0 16px', color: 'var(--brand, #20a490)' }}>Contexto (preenchido pelo analista)</h3>

          <div style={FIELD}>
            <label style={LABEL}>Resumo Executivo</label>
            <textarea style={{ ...INPUT, minHeight: 100 }} value={form.resumo_executivo}
                      placeholder="O setor X enfrenta um desafio Y. A solução proposta é Z..."
                      onChange={(e) => setForm({ ...form, resumo_executivo: e.target.value })} />
          </div>
          <div style={FIELD}>
            <label style={LABEL}>Objetivo</label>
            <textarea style={{ ...INPUT, minHeight: 80 }} value={form.objetivo}
                      placeholder="O que se pretende alcançar com esse projeto?"
                      onChange={(e) => setForm({ ...form, objetivo: e.target.value })} />
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: 16,
                      background: '#fff4e6', borderRadius: 6, marginBottom: 16,
                      color: '#c0392b', fontSize: '0.9rem' }}>
          <b>Próximo passo:</b> após criar, você será levado ao detalhe da análise onde
          preenche a <b>Análise Comparativa</b> e depois <b>convida o operador</b>.
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button type="submit" disabled={saving}
                  style={{ background: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', padding: '12px 28px',
                           border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '0.95rem',
                           fontWeight: 500 }}>
            {saving ? 'Criando…' : 'Criar análise'}
          </button>
          <button type="button" onClick={() => navigate('/inovacao/analises')}
                  style={{ background: '#ecf0f1', color: '#555', padding: '12px 20px',
                           border: 'none', borderRadius: 6, cursor: 'pointer' }}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
}
